import axios from 'axios';
import Vue from 'vue';
import store from './store';

// iOS fix
axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.baseURL = process.env.VUE_APP_API;

axios.interceptors.request.use(function (config) {
	config.params = {
		...config.params,
		'_cache': (new Date()).getTime()
	};

	if (store.state.auth) {
		config.headers.Authorization = 'Bearer ' + store.state.auth;
	}

	return config;
});

Vue.prototype.$http = axios;